<div>
  <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
  <div
    *ngIf="mobileMenuOpen"
    @AnimateChild
    class="relative z-50 lg:hidden"
    role="dialog"
    aria-modal="true"
  >
    <!--
      Off-canvas menu backdrop, show/hide based on off-canvas menu state.

      Entering: "transition-opacity ease-linear duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "transition-opacity ease-linear duration-300"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div
      @Show
      *ngIf="mobileMenuOpen"
      class="fixed inset-0 bg-gray-900/80"
    ></div>

    <div class="fixed inset-0 flex">
      <!--
        Off-canvas menu, show/hide based on off-canvas menu state.

        Entering: "transition ease-in-out duration-300 transform"
          From: "-translate-x-full"
          To: "translate-x-0"
        Leaving: "transition ease-in-out duration-300 transform"
          From: "translate-x-0"
          To: "-translate-x-full"
      -->
      <div
        @Slide
        *ngIf="mobileMenuOpen"
        class="relative mr-16 flex w-full max-w-xs flex-1"
      >
        <!--
          Close button, show/hide based on off-canvas menu state.

          Entering: "ease-in-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in-out duration-300"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div
          @Show
          *ngIf="mobileMenuOpen"
          class="absolute left-full top-0 flex w-16 justify-center pt-5"
        >
          <button
            type="button"
            class="-m-2.5 p-2.5"
            (click)="closeMobileMenu()"
          >
            <span class="sr-only">Close sidebar</span>
            <svg
              class="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <ng-container *ngTemplateOutlet="sidebar"></ng-container>
      </div>
    </div>
  </div>

  <!-- Static sidebar for desktop -->
  <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-60 lg:flex-col">
    <!-- Sidebar component, swap this element with another sidebar if you like -->
    <ng-container *ngTemplateOutlet="sidebar"></ng-container>
  </div>

  <div class="lg:pl-60 w-full h-screen flex flex-col">
    <ng-container *ngTemplateOutlet="header"></ng-container>

    <main [ngClass]="['w-full h-full overflow-auto bg-gray-50']">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Auxiliary outlet for sidebar panels -->
  <router-outlet name="sidebar"></router-outlet>
</div>

<ng-template #sidebar>
  <div
    class="h-full flex grow flex-col overflow-y-auto border-r border-gray-200 bg-white"
  >
    <p-menu [model]="sidebarItems!" styleClass="w-full border-0 pb-6">
      <ng-template pTemplate="start">
        <div class="flex shrink-0 items-center p-4 pb-0">
          <img src="/assets/logo/logo.svg" alt="logo" class="h-5" />
        </div>
      </ng-template>
    </p-menu>
    <div class="mt-auto sticky bottom-0">
      @if(!user.twoFactorEnabled) {
      <div class="p-2">
        <div class="bg-warn-100 text-warn-900 p-2 rounded flex">
          <i class="pi pi-exclamation-triangle mr-2 mt-1"></i>
          <div class="flex flex-col gap-1">
            Nemáte aktivované <br />
            2-faktorové overenie
            <a
              routerLink="/profile/security"
              [queryParams]="{ enable2fa: true }"
              class="hover:underline font-semibold inline-flex items-center gap-1"
            >
              Aktivovať <i class="pi pi-angle-right"></i>
            </a>
          </div>
        </div>
      </div>
      }

      <p-panelMenu
        #settingsMenu
        [model]="settingsItems!"
        styleClass="w-full border-0"
      >
      </p-panelMenu>
      <div class="w-full text-center text-xs text-gray-400 bg-white py-2">
        v{{ version }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #header>
  <div
    class="top-0 z-40 flex h-16 shrink-0 items-center gap-x-1 border-b border-gray-200 bg-white pl-4 shadow-sm sm:gap-x-6 sm:pl-6 lg:pl-8 pr-4"
  >
    <button
      type="button"
      class="-m-2.5 p-2.5 text-gray-700 lg:hidden"
      (click)="toggleMobileMenu()"
    >
      <span class="sr-only">Open sidebar</span>
      <svg
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
        />
      </svg>
    </button>

    <!-- Separator -->
    <div class="h-6 w-px bg-gray-200 lg:hidden" aria-hidden="true"></div>

    <p-button
      *ngIf="backRoute"
      icon="pi pi-chevron-left"
      [text]="true"
      [routerLink]="backRoute"
    />

    <div class="flex flex-1 gap-x-1 md:gap-x-4 self-stretch lg:gap-x-6">
      <div class="flex flex-1 items-center">
        <h2 class="">
          {{ title }}
        </h2>
      </div>
      <div class="flex items-center gap-x-1 sm:gap-x-4">
        <div class="flex flex-row">
          <p-button
            icon="pi pi-phone"
            severity="secondary"
            type="button"
            pTooltip="Support"
            [rounded]="true"
            [outlined]="true"
            [text]="true"
            (onClick)="openSupportDialog()"
            class="max-sm:hidden"
          >
          </p-button>
          <p-button
            type="button"
            icon="pi pi-question"
            severity="secondary"
            [rounded]="true"
            [outlined]="true"
            [text]="true"
            size="small"
            routerLink="/help"
            pTooltip="Návody/Changelog"
            class="max-sm:hidden"
          ></p-button>
          <div class="relative">
            <p-button
              icon="pi pi-bell"
              severity="secondary"
              type="button"
              pTooltip="Notifikácie"
              [rounded]="true"
              [outlined]="true"
              [text]="true"
              class="pointer-events-auto"
              (onClick)="bellClick.emit()"
            >
            </p-button>
            <p-badge
              *ngIf="unreadNotificationsCount"
              severity="danger"
              class="absolute top-1 right-1 *:block *:w-[10px] *:h-[10px] *:min-w-[10px] *:min-h-[10px] *:p-0 pointer-events-none"
            ></p-badge>
          </div>
        </div>

        <!-- Separator -->
        <div class="h-6 w-px bg-gray-200" aria-hidden="true"></div>

        @if(!user.twoFactorEnabled) {
        <p-tag
          severity="warning"
          value="2FA neaktivované"
          class="lg:hidden"
        ></p-tag>
        }

        <!-- Profile dropdown -->
        <button
          type="button"
          class="flex items-center p-1.5 hover:bg-gray-50 rounded-md"
          id="user-menu-button"
          aria-expanded="false"
          aria-haspopup="true"
          (click)="menu.toggle($event)"
        >
          <span class="sr-only">Open user menu</span>
          <kon-user-avatar [user]="user" />
          <span class="hidden lg:flex lg:items-center">
            <span class="text-sm mr-1 ml-2"> {{ user.group?.name }} </span> /
            <span
              class="text-sm ml-1 font-semibold leading-6 text-gray-900"
              aria-hidden="true"
              >{{ user.name }}</span
            >
            <svg
              class="ml-2 h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          <p-menu
            #menu
            [model]="userMenuItems"
            [popup]="true"
            [appendTo]="'body'"
          ></p-menu>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<p-dialog
  [(visible)]="supportDialogVisible"
  [modal]="true"
  header="Support"
  [style]="{ width: '25rem', maxWidth: '90%' }"
>
  <h3>Email</h3>
  <p class="pb-4 text-center">
    <i class="pi pi-envelope pr-4"></i>
    <a href="mailto:whsl@telcohub.sk">{{ 'whsl@telcohub.sk' }}</a>
  </p>
  <h3>Telefonne čislo</h3>
  <p class="text-center">
    <i class="pi pi-phone pr-4"></i>
    <a href="tel:+421412901811">+421 41 290 18 11</a>
  </p>
</p-dialog>
